import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

import { selectDashboardById } from 'features/dashboardsState';
import { DashboardLayerConfig, RootState } from 'types/types';

import DefaultCmImage from 'assets/map/default-cm-image.svg';

interface CmLayersProps {
  networkElementMarkerInfo: any;
  activeElementDetailsLayers: {}; // object where the key is the layerId and then inside has the layerdefinition and the clicked item
  hideElementDetailLayer: (
    networkElementMarkerInfo: any,
    elementDetailLayerDefinition: any
  ) => void;
  handleElementDetailsLayerClicked: (
    networkElementMarkerInfo: any,
    elementDetailLayerDefinition: any
  ) => void;
}

const CmLayers: React.FC<CmLayersProps> = ({
  hideElementDetailLayer,
  networkElementMarkerInfo,
  activeElementDetailsLayers,
  handleElementDetailsLayerClicked,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const dashboard = useSelector((state: RootState) =>
    selectDashboardById(state, 'ni-ran-advanced-map-dashboard')
  );

  const handleLayerClicked = (
    networkElementMarkerInfo: any,
    elementDetailLayerDefinition: any
  ) => {
    if (!activeElementDetailsLayers[elementDetailLayerDefinition.LayerId]) {
      handleElementDetailsLayerClicked(
        networkElementMarkerInfo,
        elementDetailLayerDefinition
      );
    } else {
      hideElementDetailLayer(
        networkElementMarkerInfo,
        elementDetailLayerDefinition
      );
    }
  };


  const filteredLayers = dashboard?.descriptor.settings.elementDetailsLayersConfig
  // first filter based on the type of clicked element
  .filter(
    (layerDefinition: DashboardLayerConfig) =>
      (!layerDefinition.TargetElementSupportedTechs ||
        layerDefinition.TargetElementSupportedTechs
          .length == 0 ||
        layerDefinition.TargetElementSupportedTechs.includes(
          networkElementMarkerInfo['TECHNOLOGY']
        )) &&
      (!layerDefinition.TargetElementSupportedLevels ||
        layerDefinition.TargetElementSupportedLevels
          .length == 0 ||
        layerDefinition.TargetElementSupportedLevels.includes(
          networkElementMarkerInfo.type ?? 'cell'))
  )
  // second filter based on text entered
  .filter((layer) =>
    layer.LayerName?.toLowerCase().includes(searchTerm.toLowerCase())
  )
  .sort((layera, layerb) => {
    // If SidePanelListModeDisplay is false, it should come before true
    return layera.SidePanelListModeDisplay === layerb.SidePanelListModeDisplay
      ? 0 : layera.SidePanelListModeDisplay ? 1 : -1;
  });

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
      }}
      className="cm-layers"
    >
      <Box className={'frequencies-filters'} sx={{ mr: 0, width: '100%' }}>
        <Box className="bands-main">
          <Box className="filters-menu-container">
            <Box className="filters-menu ea-layers">
              <TextField
                variant="outlined"
                fullWidth
                size="small"
                placeholder="Search layers..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{ mb: 2 }}
              />
              <Box key="side_pannel_layers" sx={{ mb: 2 }}>
                <Grid container spacing={1}>
                {filteredLayers?.map(layerDefinition => (
                  <>
                    <Grid
                      item
                      xs={!layerDefinition.SidePanelListModeDisplay ? 4 : 6}
                      key={layerDefinition.LayerId}
                    >
                      <Box
                        className={`ea-layer-entry ${
                          activeElementDetailsLayers[layerDefinition.LayerId]
                            ? 'active'
                            : ''
                        }`}
                      >
                        <Box
                          className={`layer-header ${
                            layerDefinition.SidePanelListModeDisplay ? 'layer-header-list' : ''
                          }`}
                          onClick={() =>
                            handleLayerClicked(
                              networkElementMarkerInfo,
                              layerDefinition
                            )
                          }
                        >
                          <Typography variant="body2">
                            {layerDefinition.LayerName}
                          </Typography>
                          {activeElementDetailsLayers[
                            layerDefinition.LayerId
                          ] ? (
                            <VisibilityOutlinedIcon fontSize="small" />
                          ) : (
                            <VisibilityOffOutlinedIcon fontSize="small" />
                          )}
                        </Box>
                        {activeElementDetailsLayers[
                          layerDefinition.LayerId
                        ] ? (
                          Object.entries(layerDefinition.LayerProperties?.
                          LegendValueToColorMapping || {}).map(([label, color]) => {
                            return (
                              <Box
                                key={layerDefinition.LayerId + label}
                                className="legend-entry"
                              >
                                <Box
                                  className="square"
                                  sx={{
                                    backgroundColor: color ? color : '#fff',
                                  }}
                                ></Box>
                                <Box> &gt; {label}</Box>
                              </Box>
                            );
                          })
                          ) : !layerDefinition.SidePanelListModeDisplay ? (
                            <img
                              src={DefaultCmImage}
                              alt="ai-icon"
                              width={'100%'}
                            />
                          ) : null}
                      </Box>
                    </Grid>
                  </>
                ))}
                </Grid>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  ); // Return null if cmLayers is empty
};

export default CmLayers;
